import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

export const PaymentReturnPageRoot = superstyled({
  name: 'PaymentReturnPage',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  }),
});

export const PaymentReturnContent = superstyled({
  name: 'PaymentReturnContent',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: 900,
    margin: '0 auto',
    padding: theme.spacing(5, 3),
  }),
});

export const PaymentReturnDetailRow = superstyled({
  tag: Box,
  name: 'PaymentReturn',
  slot: 'DetailRow',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  }),
});

export const PaymentReturnCtaButton = superstyled({
  tag: Button,
  name: 'PaymentReturn',
  slot: 'CtaButton',
  styles: ({ theme }) => ({
    alignSelf: 'stretch',

    [theme.breakpoints.up('sm')]: {
      alignSelf: 'flex-start',
    },
  }),
});

export const PaymentReturnIllustrationWrapper = superstyled({
  tag: Box,
  name: 'PaymentReturn',
  slot: 'IllustrationWrapper',
  styles: ({ theme }) => ({
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,

    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  }),
});
